// [sc-48735] Regole sui pagamenti condivise da liste, dettaglio e PDF.

/**
 * Quanto va restituito al cliente quando ha pagato più del dovuto.
 * Riceve il rimanente (dovuto meno pagato): sotto zero è un credito.
 * Il rimborso avviene fuori dal gestionale; qui lo si rende visibile.
 * Sotto il mezzo centesimo non è un credito: gli arrotondamenti non devono
 * accendere il badge.
 */
export function daRestituire(rimanente) {
  const r = Number(rimanente);
  if (!Number.isFinite(r) || r > -0.005) return 0;
  return Number((-r).toFixed(2));
}

/**
 * Il rimanente da mostrare nella colonna «Da saldare» quando non è un credito.
 * Il totale righe del server ha i millesimi (prezzo × IVA non arrotondato),
 * i pagamenti sono in centesimi: saldato per intero, il rimanente resta di
 * qualche millesimo sotto zero e verrebbe stampato «€ -0,00». Sotto il mezzo
 * centesimo è un arrotondamento, come in `daRestituire`: si mostra zero.
 * Un valore mancante passa invariato (la cella mostra «—»).
 */
export function daSaldare(rimanente) {
  const r = Number(rimanente);
  if (rimanente === null || rimanente === "" || !Number.isFinite(r)) {
    return rimanente;
  }
  return r < 0 && r > -0.005 ? 0 : r;
}

/**
 * Aggiorna in locale il pagato di una riga e, con lui, il rimanente
 * (`realTotalPrice`, che il server calcola già al netto del pagato):
 * senza, la colonna «Da saldare» resterebbe ferma fino al ricaricamento.
 */
export function aggiornaDaSaldare(quote, nuovoPagato) {
  const dopo = Number(nuovoPagato);
  if (!quote || !Number.isFinite(dopo)) return;
  const prima = Number(quote.deposit) || 0;
  quote.deposit = dopo;
  quote.realTotalPrice = (Number(quote.realTotalPrice) || 0) - (dopo - prima);
}

// Gemello di `ordineChiusoAlleModifiche` nell'API, che comunque rifiuta
// (409 ORDINE_PAGATO_IN_CONSEGNA). Gli stati vanno tenuti allineati.
const STATI_CONSEGNA_INIZIATA = [
  "Consegna Parziale",
  "In consegna",
  "Consegnato",
];

/** Pagato e con la consegna iniziata: non si modifica più. */
export function ordineNonModificabile(quote) {
  return (
    quote?.payment_state === "Pagato" &&
    STATI_CONSEGNA_INIZIATA.includes(quote?.state)
  );
}
